function backendGlobal() {
    return globalThis;
}
/** Installs a process/page-wide optional script backend. */
export function registerScriptVerificationBackend(backend) {
    backendGlobal().__bsvSdkScriptVerificationBackendV1 = backend;
}
/** Removes `backend` if it is still the active optional implementation. */
export function unregisterScriptVerificationBackend(backend) {
    const registry = backendGlobal();
    if (registry.__bsvSdkScriptVerificationBackendV1 === backend) {
        delete registry.__bsvSdkScriptVerificationBackendV1;
    }
}
/** Returns the currently registered optional script backend, if any. */
export function scriptVerificationBackend() {
    return backendGlobal().__bsvSdkScriptVerificationBackendV1;
}
//# sourceMappingURL=ScriptVerificationBackend.js.map